import { Action } from "redux";
import * as RunOnceActions from "../actions/RunOnceActions";
import { Process } from "../model/Process";
import { RunOnceDialogState } from "../model/RunOnceDialogState";

export function runOnceDialogState(state: RunOnceDialogState = new RunOnceDialogState(), action: Action): RunOnceDialogState {
    switch (action.type) {
        case RunOnceActions.SHOW_RUN_ONCE_DIALOG: {
            const showRunOnceAction = action as RunOnceActions.ShowRunOnceDialogAction;
            return new RunOnceDialogState(showRunOnceAction.processes, showRunOnceAction.agentGroupName, showRunOnceAction.manualTriggerParameters);
        }

        case RunOnceActions.CLOSE_RUN_ONCE_DIALOG:
            return new RunOnceDialogState();

        case RunOnceActions.UPDATE_RUN_ONCE_PARAMETER: {
            const updateParameterAction = action as RunOnceActions.UpdateRunOnceParameterAction;
            const clonedState = Object.assign({}, state) as RunOnceDialogState;
            const runOnceProcessModel = clonedState.runOnceProcessModel.find((process) => process.id === updateParameterAction.id);
            if (runOnceProcessModel !== undefined) {
                runOnceProcessModel.triggerData[updateParameterAction.key] = updateParameterAction.value;
            }
            return clonedState;
        }
        default:
            return state;
    }
}
